import { render, staticRenderFns } from "./Popular.vue?vue&type=template&id=004981b3&scoped=true"
import script from "./Popular.vue?vue&type=script&setup=true&lang=ts"
export * from "./Popular.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Popular.vue?vue&type=style&index=0&id=004981b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004981b3",
  null
  
)

export default component.exports